import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { fetchWrapper } from '../../../../../../_helpers';
import ContractorPaymentsList from './ContractorPaymentsList';
const PAGINATION_LIMIT = 50;
function ZealAllContractorPayroll({ providerId, providerPayroll, teamId, checkStatus }) {
    const companyID = providerPayroll?.metadata?.companyID;

    const [contractorPayments, setContractorPayments] = useState([]);
    const [isBusy, setIsBusy] = useState(false);

    async function fetchAllContractorPayments() {
        if (!companyID || !providerId) {
            return;
        }
        try {
            setIsBusy(true);
            const params = new URLSearchParams();
            if (checkStatus) params.set('status', checkStatus);
            if (teamId) params.set('team', teamId);
            const queryString = params.toString();

            const payments = await fetchWrapper.get(
                `/evv/payroll/zeal/contractor/${companyID}/payments${queryString ? `?${queryString}` : ''}&limit=${PAGINATION_LIMIT}`
            );

            setContractorPayments(Array.isArray(payments) ? payments : []);
        } catch (error) {
            if (error?.name === 'AbortError') return;
            toast.error("Couldn't fetch contractor payments");
        } finally {
            setIsBusy(false);
        }
    }

    useEffect(() => {
        if (companyID && providerId) {
            fetchAllContractorPayments();
        }
    }, [checkStatus, companyID, providerId, teamId]);

    if (!providerId) {
        return <div>Please select a provider</div>;
    }

    return (
        <ContractorPaymentsList
            payments={contractorPayments}
            setPayments={setContractorPayments}
            isBusy={isBusy}
            teamId={teamId}
            companyID={companyID}
            title={`Contractor Payments: ${PAGINATION_LIMIT === contractorPayments.length ? `Recent ${PAGINATION_LIMIT} pays` : ''}`}
        />
    );
}

export default ZealAllContractorPayroll;
